import React, { Fragment, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import DefaultLayout from '../components/DefaultLayout'
import Empty from '../components/Empty'
import styled from 'styled-components'
import { setUpdatedCart } from '../redux/auth-reducer'

const Delete = styled.div``

const CartList = ({ list, dispatch }) => {
	const [search, setSearch] = useState('')

	const deleteItem = (product) => {
		dispatch(
			setUpdatedCart(
				{
					id: product.id,
				},
				'delete'
			)
		)
	}

	return (
		<Fragment>
			<div className="cart-header">
				<h1>
					{list.reduce((partial_sum, a) => partial_sum + a.count, 0)}{' '}
					items in your cart
				</h1>
				<div className="simple-input">
					<svg
						width="20"
						height="20"
						viewBox="0 0 21 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M19.4999 17.8688L18.3687 19L14.9743 15.6064L16.1055 14.4744L19.4999 17.8688ZM9.89989 14.2C7.25349 14.2 5.09989 12.0472 5.09989 9.40003C5.09989 6.75363 7.25349 4.60003 9.89989 4.60003C12.5463 4.60003 14.6999 6.75363 14.6999 9.40003C14.6999 12.0472 12.5463 14.2 9.89989 14.2ZM9.9 3C6.3656 3 3.5 5.8656 3.5 9.4C3.5 12.9344 6.3656 15.8 9.9 15.8C13.4344 15.8 16.3 12.9344 16.3 9.4C16.3 5.8656 13.4344 3 9.9 3Z"
							fill="#787878"
						></path>
					</svg>
					<input
						type="text"
						placeholder="Search product #"
						onChange={(e) => setSearch(e.target.value)}
					/>
				</div>
			</div>
			<div className="cart-content">
				<div className="cart-list">
					{list
						.filter((el) =>
							search.length
								? el.name
										.toLowerCase()
										.includes(search.toLowerCase())
								: true
						)
						.map((i) => (
							// <div>{i.name}, {i.id}. Kolvo: {i.count}</div>
							<div className="cart-item">
								<div className="cart-image">
									<img src={i.image} alt="" />
								</div>
								<div className="cart-item__info">
									<h2>{i.name}</h2>
									<span>Amount: {i.count}</span>
									<Delete onClick={() => deleteItem(i)}>
										<svg
											width="20"
											height="20"
											viewBox="0 0 21 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M8.4 14.2H9.8V8.6H8.4V14.2ZM11.2 14.2H12.6V8.6H11.2V14.2ZM7 15.6H14V7.2H7V15.6ZM8.4 5.8H12.6V4.4H8.4V5.8ZM14 5.8V3H7V5.8H3.5V7.2H5.6V17H15.4V7.2H17.5V5.8H14Z"
												fill="#ff265a"
											></path>
										</svg>
									</Delete>
								</div>
								<h2 className="cart-item__price">
									{i.price * i.count} мавродиков
								</h2>
							</div>
						))}
				</div>
				<div className="cart-right">
					<span>
						<span>Total</span>
						<span>
							{list.reduce(
								(partial_sum, a) =>
									partial_sum + a.count * a.price,
								0
							)}
						</span>
					</span>
					<NavLink to="/checkout" className="primary-btn">
						Go to checkout
						<svg
							width="20"
							height="20"
							viewBox="0 0 21 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M11.9444 10L6.72218 4.77782L8.27782 3.22218L15.0556 10L8.27782 16.7778L6.72218 15.2222L11.9444 10Z"
								fill="#FFFFFF"
							></path>
						</svg>
					</NavLink>
				</div>
			</div>
		</Fragment>
	)
}

const Cart = (props) => {
	return (
		<DefaultLayout>
			<div className="cart-page">
				{props.cart.length ? (
					<CartList list={props.cart} dispatch={props.dispatch} />
				) : (
					<Empty />
				)}
			</div>
		</DefaultLayout>
	)
}

let mapStateToProps = (state) => {
	return {
		cart: state.auth.cart,
	}
}

export default connect(mapStateToProps, null)(Cart)
